// import { getServerSideProps } from "@translations/next";
import WrapperProvider from "@providers/WrapperProvider";
import OffersContainer from "@containers/OffersContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import _ from "lodash";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import StrapiService from "@services/StrapiService";
import OfferCategoryService from "@services/OfferCategoryService";
import FooterService from "@services/FooterService";

export default function Home(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <OffersContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");

  // Get PageData
  StrapiService.set("id", "hotel65-offer-page");
  const res = await StrapiService.find({ populate: "deep", locale });

  // Get Offer Category
  const resOfferCategory = await OfferCategoryService.find({
    filters: {
      hotel: {
        slug: {
          $eq: "amanaki-boutique-saigon",
        },
      },
    },
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);
  return {
    hotel: "amanaki-boutique-saigon",
    pageData: _.get(res, "data", {}),
    offerCategories: _.get(resOfferCategory, "data", []),
    footerData,
  };
});
